/**
 * Extracts the first subdomain from the REACT_APP_API_URL environment variable.
 * @returns {string | null} The first subdomain if present, otherwise null.
 */
const getFirstSubdomain = () => {
  const { hostname } = window.location;

  // If it's localhost or an IP, we might want a fallback or handle it specifically
  if (hostname === 'localhost' || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    return '';
  }
  const parts = hostname.split('.');

  const blocked = [
    'facility-dev',
    'facility-test',
    'facility',
    'localhost',
    'partner-dev',
    'partner-test',
    'partner',
  ];

  if (parts?.[0] && blocked.some((d) => parts[0].includes(d))) {
    return '';
  }

  // Handle cases like localhost or single part domains
  if (parts.length < 2) {
    return '';
  }

  return parts[0];
};

export default getFirstSubdomain;
